import type { PayrollFormValues } from "./PayrollEntryForm";

/** Sample form data for auto-fill on PayrollNewPage. employeeId left empty — user must select. */
export const payrollFormSamples: Omit<PayrollFormValues, "employeeId">[] = [
  {
    baseSalary: "3200000",
    earnings: [
      { id: "e1", name: "ໂບນັສປະຈຳເດືອນ", amount: "200000" },
      { id: "e2", name: "ຄ່າຂົນສົ່ງ", amount: "150000" },
      { id: "e3", name: "ຄ່າອາຫານ", amount: "100000" },
    ],
    deductions: [
      { id: "d1", name: "ພາສີ income", amount: "250000" },
      { id: "d2", name: "ປະກັນສັງຄົມ", amount: "50000" },
    ],
    notes: "ເງິນເດືອນປະຈຳເດືອນ ພະນັກງານປົກກະຕິ.",
  },
  {
    baseSalary: "4500000",
    earnings: [
      { id: "e1", name: "OT ເວລາເຮັດວຽກ", amount: "375000" },
      { id: "e2", name: "ໂບນັສຜົນງານ", amount: "500000" },
    ],
    deductions: [
      { id: "d1", name: "ພາສີ income", amount: "400000" },
      { id: "d2", name: "ປະກັນສັງຄົມ", amount: "67500" },
      { id: "d3", name: "ກອງທຶນບຳນານ", amount: "225000" },
    ],
    notes: "ລາຍໄດ້ເພີ່ມຈາກ OT ແລະ ໂບນັສຕາມຜົນງານ.",
  },
  {
    baseSalary: "2800000",
    earnings: [
      { id: "e1", name: "ຄ່າທີ່ພັກ", amount: "80000" },
      { id: "e2", name: "ຄ່າເວລາລົງທຶນ", amount: "50000" },
    ],
    deductions: [
      { id: "d1", name: "ພາສີ income", amount: "180000" },
      { id: "d2", name: "ປະກັນສັງຄົມ", amount: "42000" },
    ],
    notes: "",
  },
  {
    baseSalary: "5500000",
    earnings: [
      { id: "e1", name: "ໂບນັສປະຈຳເດືອນ", amount: "300000" },
      { id: "e2", name: "ຄ່າຂົນສົ່ງ", amount: "200000" },
      { id: "e3", name: "ຄ່າອາຫານ", amount: "150000" },
      { id: "e4", name: "ຄ່າທີ່ພັກ", amount: "100000" },
    ],
    deductions: [
      { id: "d1", name: "ພາສີ income", amount: "450000" },
      { id: "d2", name: "ປະກັນສັງຄົມ", amount: "82500" },
      { id: "d3", name: "ກອງທຶນບຳນານ", amount: "275000" },
    ],
    notes: "ຕຳແໜ່ງບັນຊາ ລາຍໄດ້ເພີ່ມຕາມນະໂຍບາຍບໍລິສັດ.",
  },
  {
    baseSalary: "1800000",
    earnings: [{ id: "e1", name: "ຄ່າອາຫານ", amount: "50000" }],
    deductions: [
      { id: "d1", name: "ພາສີ income", amount: "100000" },
      { id: "d2", name: "ປະກັນສັງຄົມ", amount: "27000" },
    ],
    notes: "ພະນັກງານໃໝ່ ເດືອນທົດສອບວຽກ.",
  },
];
